import './reset-password.page.css'
import logo from '../../../assets/images/logo.png'
import { Link, useSearchParams } from 'react-router-dom'
import {
  useResetPassword,
  useResetPasswordForm,
} from '../auth.hooks'
import { LoadingButton } from '@mui/lab'
import { FormProvider } from 'react-hook-form'
import TextInputField from '../../../components/fields/text-input-field/text-input-field.component'
import { Alert, Snackbar, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import useSubmitLock from 'hooks/use-submit-lock'

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams()
  const userId = searchParams.get('userId')
  const code = searchParams.get('code')
  const [isResetting, setIsResetting] = useState(false)

  const formMethods = useResetPasswordForm()
  const { isSubmitting, wrapFormSubmit } = useSubmitLock()
  const {
    handleResetPassword,
    resetError,
    resetErrorOpen,
    setResetErrorOpen,
    resetSuccess,
    navigate,
  } = useResetPassword()

  useEffect(() => {
    if (!userId || !code) {
      setResetErrorOpen(true)
    }
  }, [userId, code, setResetErrorOpen])

  const onSubmit = async (data: { password: string; confirmPassword: string }) => {
    if (!userId || !code) {
      setResetErrorOpen(true)
      return
    }

    if (data.password !== data.confirmPassword) {
      return
    }

    setIsResetting(true)
    const result = await handleResetPassword(userId, code, data.password)
    setIsResetting(false)

    if (result.success) {
      setTimeout(() => {
        navigate('/auth/login')
      }, 2000)
    }
  }

  if (!userId || !code) {
    return (
      <div className="login-page">
        <div className="login-container">
          <h1>Reset Password</h1>
          <img src={logo} alt="Transpots Logo" className="logo" />
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Invalid reset link. Please request a new password reset.</p>
            <Link to="/auth/login" style={{ color: '#0075ff', textDecoration: 'none' }}>
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>Reset Password</h1>
        <img src={logo} alt="Transpots Logo" className="logo" />
        {resetSuccess ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Alert severity="success" sx={{ mb: 2 }}>
              Password reset successfully!
            </Alert>
            <Link to="/auth/login" style={{ color: '#0075ff', textDecoration: 'none' }}>
              Go to Login
            </Link>
          </div>
        ) : (
          <FormProvider {...formMethods}>
            <form onSubmit={wrapFormSubmit(formMethods.handleSubmit, onSubmit)}>
              <Stack spacing={2} sx={{ width: '320px' }}>
                <TextInputField
                  name="password"
                  placeholder="New Password"
                  type="password"
                  variant="standard"
                />
                <TextInputField
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  type="password"
                  variant="standard"
                />
                <LoadingButton
                  variant="contained"
                  fullWidth
                  loading={isResetting || isSubmitting}
                  disabled={isResetting || isSubmitting}
                  sx={{
                    borderRadius: '4px',
                    '&.Mui-disabled': {
                      bgcolor: 'action.disabledBackground',
                      color: 'action.disabled',
                    },
                  }}
                  type="submit"
                >
                  RESET PASSWORD
                </LoadingButton>
              </Stack>
            </form>
          </FormProvider>
        )}

        <div className="form-footer">
          <Link to="/auth/login">Back to Login</Link>
        </div>
      </div>

      <Snackbar
        open={resetErrorOpen}
        autoHideDuration={6000}
        onClose={() => setResetErrorOpen(false)}
      >
        <Alert severity="error">{resetError}</Alert>
      </Snackbar>
    </div>
  )
}

export default ResetPasswordPage

